module.exports = __webpack_public_path__ + "img/logo-horizontal-green.3a2d2776.svg";